import { Calendar, formatDate } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; // optional for styling
import "./filter-switch.scss";

let RenbrookEventCategoriesChecked = [];
let RenbrookEventCategoriesUnchecked = [];
/**
 * https://github.com/fullcalendar/fullcalendar/blob/495d925436e533db2fd591e09a0c887adca77053/packages/common/src/common/StandardEvent.tsx#L79
 */
/*
function renderInnerContent(innerProps) {
	return (
		<div className="fc-event-main-frame">
			{innerProps.timeText && (
				<div className="fc-event-time">{innerProps.timeText}</div>
			)}
			<div className="fc-event-title-container">
				<div className="fc-event-title fc-sticky">
					{innerProps.event.title || <Fragment>&nbsp;</Fragment>}
				</div>
			</div>
		</div>
	);
}
function renderListInnerContent(innerProps) {
	return (
		<div className="fc-event-main-frame">
			{innerProps.timeText && (
				<div className="fc-event-time">{innerProps.timeText}</div>
			)}
			<div className="fc-event-title-container">
				<div className="fc-event-title fc-sticky">
					{innerProps.event.title || <Fragment>&nbsp;</Fragment>}
				</div>
			</div>
		</div>
	);
}
*/
export default function allSchoolCalendar(today) {
  let calendarEl = document.querySelector("#calendar.school");
  if (null == calendarEl) return;
  var eventCounter = 0;
  let calendar = new Calendar(calendarEl, {
    plugins: [dayGridPlugin, listPlugin],
    height: "auto",
    headerToolbar: {
      left: "prev,next today",
      center: "title",
      right: "dayGridMonth listMonth",
    },
    eventDidMount: function (info) {
      if ("listMonth" == info.view.type) {
        let td = info.el.querySelector(".fc-list-event-title");
        let details = document.createElement("div");

        if (info.event.extendedProps.Location) {
          console.log(info);
          let location = document.createElement("p");
          location.appendChild(
            document.createTextNode(info.event.extendedProps.Location)
          );
          details.appendChild(location);
        }
        if (info.event.extendedProps.Description) {
          let description = document.createElement("p");
          description.innerHTML = info.event.extendedProps.Description;
          details.appendChild(description);
        }
        td.appendChild(details);
      } else {
        if (info.event.extendedProps.Description) {
          // This would be for the GRID layouts to add a Tooltip
          let p = document.createElement("p");
          p.innerHTML = info.event.extendedProps.Description;
          tippy(info.el, {
            content: p,
            allowHTML: true,
            interactive: true,
            appendTo: () => document.body,
            theme: "renbrook",
          });
          let fa = document.createElement("i");
          fa.classList.add("fas", "fa-comment-alt");
          info.el.querySelector(".fc-event-title").appendChild(fa);
        }
      }
    },
    dayMaxEventRows: 12,
    initialView: "dayGridMonth",
    fixedWeekCount: false,
    initialDate: today,
    navLinks: true, // can click day/week names to navigate views
    editable: true,
    events: fetch_events,
  });

  calendar.render();

  let filterWrapper = document.querySelector("#calendar-filter");
  Object.keys(renbrook.calendar.categories).forEach(function (item) {
    let label = document.createElement("label");
    label.setAttribute("class", "switch");

    // Create a new element
    let checkbox = document.createElement("input");
    checkbox.setAttribute("type", "checkbox");
    checkbox.setAttribute("value", 1);
    checkbox.setAttribute("data-category", item);
    checkbox.setAttribute("name", "mapFilter[" + item + "]");
    checkbox.setAttribute("checked", "checked");
    checkbox.addEventListener("change", refetch);
    //<label class="switch"><input type="checkbox" value=1 data-blacat="%1$s" name=blaMapfilter[%1$s]><span class="slider round"></span></label>
    label.appendChild(checkbox);
    let span = document.createElement("span");
    span.setAttribute("class", "slider round");
    label.appendChild(span);
    let div = document.createElement("div");
    div.appendChild(label);
    div.appendChild(
      document.createTextNode(" " + renbrook.calendar.categories[item])
    );
    // Insert the new node after the last element in the parent node
    // ...<li>Item 3</li><li>I am new here.</li>
    filterWrapper.appendChild(div);
  });

  //	let filters = document.querySelectorAll("#calendar-filter input");
  //filterWrapper.addEventListener("change", calendar.refetchEvents());
  function refetch() {
    calendar.refetchEvents();
  }
}

function fetch_events(info, successCallback, failureCallback) {
  console.log("refetched");
  RenbrookEventCategoriesChecked = [];
  document
    .querySelectorAll("#calendar-filter input:checked")
    .forEach(function (ele) {
      RenbrookEventCategoriesChecked.push(ele.dataset.category);
    });
  RenbrookEventCategoriesUnchecked = [];
  document
    .querySelectorAll("#calendar-filter input:not(:checked)")
    .forEach(function (ele) {
      RenbrookEventCategoriesUnchecked.push(ele.dataset.category);
    });
  console.log(RenbrookEventCategoriesChecked, RenbrookEventCategoriesUnchecked);
  let filteredEvents = renbrook.calendar.events.filter(function (event) {
    if (
      arrayIntersect(RenbrookEventCategoriesUnchecked, event.classNames)
        .length &&
      0 ==
        arrayIntersect(RenbrookEventCategoriesChecked, event.classNames).length
    ) {
      return false;
    }

    return true;
  });
  successCallback(filteredEvents);
}

/**
 * Get the intersecting values between two arrays
 * @param  {Array} arr1 The first array
 * @param  {Array} arr2 The second array
 * @return {Array}      The array of overlapping values
 *
 * https://gomakethings.com/how-to-find-the-intersecting-values-of-two-arrays-with-vanilla-javascript/
 */
function arrayIntersect(arr1, arr2) {
  return arr1.filter(function (item) {
    return arr2.includes(item);
  });
}
